(() => {
  if (window.RetroPartyCartUpsellLoaded) return;
  window.RetroPartyCartUpsellLoaded = true;

  const rootPath = () => (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  let mutationInProgress = null;
  let refreshController = null;
  let operationId = 0;

  function replaceSection(sectionId, html, validateOnly = false) {
    if (!html || !html.trim()) throw new Error('cart_section_invalid');
    const template = document.createElement('template');
    template.innerHTML = html.trim();

    if (sectionId === 'cart-icon-bubble') {
      const currentBubble = document.getElementById('cart-icon-bubble');
      const nextBubble = template.content.querySelector('#cart-icon-bubble');
      if (!currentBubble || !nextBubble) throw new Error('cart_section_invalid');
      if (validateOnly) return;
      currentBubble.replaceWith(nextBubble);
      window.RetroPartyCartSync?.syncHeaderCartSoon?.();
      return;
    }

    if (sectionId === 'cart-drawer') {
      const currentDrawer = document.querySelector('cart-drawer');
      const currentCart = document.getElementById('CartDrawer');
      const nextDrawer = template.content.querySelector('cart-drawer');
      const nextCart = template.content.querySelector('#CartDrawer');
      if (!currentDrawer || !currentCart || !nextDrawer || !nextCart) {
        throw new Error('cart_section_invalid');
      }
      if (validateOnly) return;

      currentDrawer.classList.toggle('is-empty', nextDrawer.classList.contains('is-empty'));
      currentCart.replaceWith(nextCart);
      window.RetroPartyCartSync?.syncHeaderCartSoon?.();
      return;
    }

    const wrappedId = 'shopify-section-' + sectionId;
    const current = document.getElementById(wrappedId) || document.getElementById(sectionId);
    if (!current) throw new Error('cart_section_invalid');

    const next = template.content.getElementById(current.id);
    if (!next) throw new Error('cart_section_invalid');
    if (validateOnly) return;
    current.replaceWith(next);
  }

  async function refreshSections(sections, signal, currentOperationId) {
    const cleanSections = [...new Set((sections || '').split(',').map(s => s.trim()).filter(Boolean))];
    if (!cleanSections.length) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sections', cleanSections.join(','));

    const response = await fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal
    });

    const data = await response.json().catch(() => null);
    if (currentOperationId !== operationId || signal?.aborted) return;
    if (!response.ok || !data || typeof data !== 'object') {
      throw new Error('cart_sections_failed');
    }

    const missingSections = cleanSections.filter((sectionId) => typeof data[sectionId] !== 'string');
    if (missingSections.length) {
      throw new Error('cart_sections_missing');
    }

    cleanSections.forEach((sectionId) => replaceSection(sectionId, data[sectionId], true));
    cleanSections.forEach((sectionId) => replaceSection(sectionId, data[sectionId]));
    window.RetroPartyCartSync?.syncHeaderCartSoon?.();
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    drawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-rp-cart-upsell-add]');
    if (!button) return;

    event.preventDefault();
    if (mutationInProgress) return;

    const variantId = button.dataset.variantId;
    const upsellRoot = button.closest('[data-rp-cart-upsell]');
    const status = upsellRoot?.querySelector('[data-rp-upsell-status]');
    if (!variantId || button.dataset.rpLoading === 'true') return;

    const sourceProductId = button.dataset.rpUpsellSourceProduct || upsellRoot?.dataset.rpUpsellSourceProduct || '';
    const upsellProductId = button.dataset.rpUpsellProduct || upsellRoot?.dataset.rpUpsellProduct || '';
    const upsellVariantId = button.dataset.rpUpsellVariant || upsellRoot?.dataset.rpUpsellVariant || variantId;
    const upsellContext = button.dataset.rpUpsellContext || upsellRoot?.dataset.rpUpsellContext || 'cart';
    const currentOperationId = ++operationId;
    mutationInProgress = { id: currentOperationId };

    const buttonStates = [...document.querySelectorAll('[data-rp-cart-upsell-add]')].map((candidate) => ({
      button: candidate,
      disabled: candidate.disabled,
      loading: candidate.dataset.rpLoading,
      text: candidate.textContent,
    }));
    buttonStates.forEach((state) => {
      state.button.dataset.rpLoading = 'true';
      state.button.disabled = true;
      if (state.button === button) {
        state.button.textContent = button.dataset.rpLabelLoading || state.text;
      }
    });

    if (status) {
      status.textContent = '';
      status.classList.add('visually-hidden');
    }

    let itemAdded = false;

    try {
      const response = await fetch(`${rootPath()}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: Number(upsellVariantId || variantId),
          quantity: 1,
          properties: {
            _upsell: 'cart',
            _upsell_source_product: sourceProductId,
            _upsell_product: upsellProductId,
            _upsell_variant: upsellVariantId,
            _upsell_context: upsellContext
          }
        })
      });

      const item = await response.json().catch(() => null);
      if (!response.ok || !item || !item.id) throw new Error('cart_add_failed');
      itemAdded = true;

      refreshController?.abort();
      const controller = new AbortController();
      refreshController = controller;
      const refreshTimeout = window.setTimeout(() => controller.abort(), 10000);

      try {
        await refreshSections(button.dataset.sections, controller.signal, currentOperationId);
      } catch {
        if (status) {
          status.textContent = upsellRoot?.dataset.rpUpsellPartial || '';
          status.classList.remove('visually-hidden');
        }

        try {
          await refreshSections('cart-icon-bubble', controller.signal, currentOperationId);
        } catch {
          window.RetroPartyCartSync?.syncHeaderCartSoon?.();
        }

        window.location.assign(`${rootPath()}cart`);
        return;
      } finally {
        window.clearTimeout(refreshTimeout);
        if (refreshController === controller) refreshController = null;
      }

      openCartDrawer();
      document.dispatchEvent(new CustomEvent('retroparty:cart-upsell-added', {
        bubbles: true,
        detail: { sourceProductId, upsellProductId, upsellVariantId, upsellContext }
      }));
    } catch {
      if (status) {
        status.textContent = itemAdded
          ? upsellRoot?.dataset.rpUpsellPartial || ''
          : upsellRoot?.dataset.rpUpsellError || '';
        status.classList.remove('visually-hidden');
      }
    } finally {
      if (mutationInProgress?.id === currentOperationId) mutationInProgress = null;
      buttonStates.forEach((state) => {
        state.button.disabled = state.disabled;
        state.button.textContent = state.text;
        if (state.loading === undefined) delete state.button.dataset.rpLoading;
        else state.button.dataset.rpLoading = state.loading;
      });
    }
  });})();
